import MailIcon from '~/assets/icons/Mail';

import AuthPanel from '../AuthPanel';

export default function EmailSubmitting() {
  return (
    <AuthPanel className="gap-2 px-2 py-4">
      <MailIcon width="42" height="42" stroke="#A9A9A9" />
      <span className="text-grey-hide">Sending confirmation...</span>
    </AuthPanel>
  );
}
